export default __webpack_public_path__ + "static/media/placeholder-button-next-prev.ff2e51e4.png";